import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { copy } from '@/utils/cohort';
import { isEmpty, isEmptyValue, sortByProperty } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';
import SelectionList from './selection-list/selection-list';

@Component({
    name: 'classification-sub-fw-form',
    components: {
        'selection-list': SelectionList,
    },
})

export default class ClassificationSubFwForm extends Vue {

    @Prop({ default: {} })
    public userData: any;

    private classification: any = [];

    private classSubData = {};

    private isDisplayList: boolean = false;

    private isLoading: boolean = false;

    private classificationDisplayList: any = {
        classification: {
            displayText: 'Classifications',
            modelKey: 'classification',
            modelValue: '',
            itemList: [],
            selectedItem: [],
            eventBind: {},
            parentWise: {},
            recentlySelected: {},
            checked: false,
            indeterminate: false,
        },
        subject: {
            displayText: 'Subjects',
            modelKey: 'subject',
            modelValue: [],
            itemList: [],
            selectedItem: [],
            eventBind: {},
            parentWise: {},
            recentlySelected: {},
            checked: false,
            indeterminate: false,
            // eventBind: { change: this.onUpdateFile.bind(this) },
        },
        // framework: {
        //     displayText: 'Frameworks',
        //     // field: 'b-form-input',
        //     modelKey: 'framework',
        //     modelValue: '',
        //     itemList: [],
        //     selectedItem: [],
        //     eventBind: {},
        //     parentWise: {},
        //     recentlySelected: {},
        //     checked: false,
        //     indeterminate: false,
        // },
    };

    private selectedItemByCat: any = {
        classification: {},
        subject: {},
        // framework: {},
    };

    private isExecutedParentWise: boolean = false;

    private selectedItemDisplayList: any = {
        classification: [],
        subject: [],
        // framework: [],
    };

    private created() {
        this.categoryLists();
        // console.log('userData', this.userData);
    }

    private async categoryLists() {
        this.isDisplayList = false;
        this.isLoading = true;
        const that = this;
        const classification = this.classificationDisplayList.classification.modelKey;
        this.classification = await taxonomyAPI.fetchTaxonomyClassifications();
        // this.classification = await tenantSettingsAPI.fetchClassification();
        // console.log('this.classification', this.classification);
        for await (const [index, iterator] of this.classification.entries()) {
            iterator.selectedItem = [];
            const subjectList = await taxonomyAPI.fetchSubjects(iterator.id) || [];
            // sortByProperty(subjectList, 'title', 'ASC');
            iterator.subjects = subjectList;
            for (const subject of iterator.subjects) {
                subject.selectedItem = [];
                if (subject && subject.length > 0) {
                    for (const fw of subject.frameworks) {
                        fw.selectedItem = [];
                    }
                }
            }
            if (index >= this.classification.length - 1) {
                this.classificationDisplayList.classification.itemList = this.classification;
                this.onClick(this.classification[0], classification);
            }
        }
    }

    private selectedItem() {
        const doNothing = 'nothing';
    }

    private onClick(item: any, displayFor: any) {
        const classification = this.classificationDisplayList.classification.modelKey;
        const subject = this.classificationDisplayList.subject.modelKey;
        // const fw = this.classificationDisplayList.framework.modelKey;
        if (displayFor === classification) {
            this.classificationDisplayList.subject.itemList = [];
            // this.classificationDisplayList.framework.itemList = [];
            const itrClassIndex = this.classification.findIndex((itemLocal: any) =>
                itemLocal.id === item.id);
            if (!isEmpty(itrClassIndex) && itrClassIndex !== -1) {
                const classifiedObj = this.classification[itrClassIndex];
                this.classificationDisplayList.subject.itemList = classifiedObj.subjects;
                // this.classificationDisplayList.framework.itemList = (!isEmptyValue(classifiedObj.subjects)
                // && classifiedObj.subjects.length > 0 && !isEmptyValue(classifiedObj.subjects[0])
                // && !isEmptyValue(classifiedObj.subjects[0].frameworks))
                //     ? classifiedObj.subjects[0].frameworks : [];

                this.classificationDisplayList.classification.recentlySelected = item;
                this.classificationDisplayList.subject.recentlySelected =
                    this.classificationDisplayList.subject.itemList[0];
                // this.classificationDisplayList.framework.recentlySelected =
                // this.classificationDisplayList.framework.itemList[0];
                setTimeout(() => {
                    this.displaySelectedFooterList(displayFor);
                    // console.log('this.classificationDisplayList1', this.classificationDisplayList);

                }, 500);
            }
        } else if (displayFor === subject) {
            // this.classificationDisplayList.framework.itemList = [];
            const splitObj = item.id.split('.');
            const itrClassIndex = this.classification.findIndex((itemLocal: any) => itemLocal.code === splitObj[0]);
            if (!isEmpty(itrClassIndex) && itrClassIndex !== -1) {
                const itrSubjectIndex = this.classification[itrClassIndex].subjects.
                    findIndex((itemLocal: any) => itemLocal.id === item.id);
                if (!isEmpty(itrSubjectIndex) && itrSubjectIndex !== -1) {
                    const FwList = this.classification[itrClassIndex].subjects[itrSubjectIndex];
                    // this.classificationDisplayList.framework.itemList = FwList.frameworks;
                }
                this.classificationDisplayList.subject.recentlySelected = item;
                // this.classificationDisplayList.framework.recentlySelected =
                // this.classificationDisplayList.framework.itemList[0];
                setTimeout(() => {
                    this.displaySelectedFooterList(displayFor);
                    // console.log('this.classificationDisplayList2', this.classificationDisplayList);
                }, 500);
            }
        }
    }

    private onSelectAll(item: any, displayFor: any) {
        const classification = this.classificationDisplayList.classification;
        const subject = this.classificationDisplayList.subject;
        // const framework = this.classificationDisplayList.framework;
        if (displayFor === classification.displayText) {
            this.loopSelectAll(this.classificationDisplayList.classification);
        } else if (displayFor === subject.displayText) {
            this.loopSelectAll(this.classificationDisplayList.classification);
            // } else if (displayFor === framework.displayText) {
            //     this.loopSelectAll(this.classificationDisplayList.classification);
        }
    }

    private loopSelectAll(list: any) {
        if (list.itemList && list.itemList.length > 0) {
            for (const iterator of list.itemList) {
                iterator.checked = true;
            }
        }
    }

    private onCheck(item: any, displayFor: any) {
        const classification = this.classificationDisplayList.classification;
        const subject = this.classificationDisplayList.subject;
        // const framework = this.classificationDisplayList.framework;
        if (displayFor === classification.modelKey) {
            this.classificationDisplayList.subject.itemList = [];
            // this.classificationDisplayList.framework.itemList = [];
            this.onClick(item, classification.modelKey);
            this.findAddRemove(item, this.classificationDisplayList.classification, item.checked, displayFor);
        } else if (displayFor === subject.modelKey) {
            // this.classificationDisplayList.framework.itemList = [];
            this.onClick(item, subject.modelKey);
            // if (item.checked) {
            //     this.onParent(item);
            // }
            this.findAddRemove(item, this.classificationDisplayList.subject, item.checked, displayFor);
            // } else if (displayFor === framework.modelKey) {
            //     this.classificationDisplayList.framework.itemList = [];
            //     if (item.frameworks && item.frameworks.length) {
            //         const fwList = copy(item.frameworks);
            //         setTimeout(() => {
            //             this.classificationDisplayList.framework.itemList = fwList;
            //         });
            //     }
        }
    }

    private autoSelectChild(item: any, displayFor: any) {
        const classification = this.classificationDisplayList.classification;
        const subject = this.classificationDisplayList.subject;
        // const framework = this.classificationDisplayList.framework;
        const isChecked = item.checked;
        if (displayFor === classification.modelKey) {
            // console.log('1');
            const itrClassIndex = this.classification.findIndex((itemLocal: any) => itemLocal.id === item.id);
            if (itrClassIndex !== -1) {
                const itrClassObject = this.classification[itrClassIndex];
                for (const subjectIrt of itrClassObject.subjects) {
                    subjectIrt.checked = isChecked;
                    this.selectORRemove(subjectIrt, 'subject');
                    // for (const fw of subjectIrt.frameworks) {
                    //     fw.checked = isChecked;
                    //     this.selectORRemove(fw, 'framework');
                    // }
                }
            }
        } else if (displayFor === subject.modelKey) {
            this.selectORRemove(item, 'subject');
            const splitObj = item.id.split('.');
            const itrClassIndex = this.classification.findIndex((itemLocal: any) => itemLocal.code === splitObj[0]);
            if (itrClassIndex !== -1) {
                const itrSubjectIndex = this.classification[itrClassIndex].subjects.
                    findIndex((itemLocal: any) => itemLocal.id === item.id);
                if (itrSubjectIndex !== -1) {
                    const itrSubObject = this.classification[itrClassIndex].subjects[itrSubjectIndex];
                    // const fWList = itrSubObject.frameworks;
                    // if (fWList && fWList.length > 0) {
                    //     for (const fw of fWList) {
                    //         fw.checked = isChecked;
                    //         this.selectORRemove(fw, 'framework');
                    //     }
                    // }
                }
            }
            // } else if (displayFor === framework.modelKey) {
            //     this.selectORRemove(item, 'framework');
        }
    }

    private findInArray(sendItem: any, list: []) {
        return list.findIndex((item: any) => item.id === sendItem.id);
    }

    private selectORRemove(sendItem: any, catItem: any) {
        this.classificationDisplayList[catItem].selectedItem =
            this.classificationDisplayList[catItem].selectedItem || [];
        const classIndex = this.findInArray(sendItem, this.classificationDisplayList[catItem].selectedItem);
        if (sendItem.checked && !isEmpty(classIndex) && classIndex === -1) {
            this.classificationDisplayList[catItem].selectedItem.push(sendItem);
        }
        if (!sendItem.checked && classIndex !== -1) {
            const classItemListIndex = this.findInArray(sendItem, this.classificationDisplayList[catItem].itemList);
            if (!isEmpty(classIndex) && !isEmpty(classItemListIndex) && classItemListIndex !== -1) {
                this.classificationDisplayList[catItem].itemList[classItemListIndex].checked = false;
                this.classificationDisplayList[catItem].itemList[classItemListIndex].indeterminate = false;
                this.classificationDisplayList[catItem].selectedItem.splice(classIndex, 1);
            }
        }
    }

    private selectORRemoveForParent(sendItem: any, catItem: any) {
        this.classificationDisplayList[catItem].selectedItem =
            this.classificationDisplayList[catItem].selectedItem || [];
        const classIndex = this.findInArray(sendItem, this.classificationDisplayList[catItem].selectedItem);
        if (sendItem.checked && classIndex === -1) {
            this.classificationDisplayList[catItem].selectedItem.push(sendItem);
        }
        if (!sendItem.checked && classIndex !== -1) {
            this.classificationDisplayList[catItem].selectedItem.splice(classIndex, 1);
        }
    }

    private parentIdWise(list: any, catItem: any) {
        list.parentWise = list.selectedItem.reduce((r: any, a: any) => {
            const sliptArray = a.id.split('.');
            if (sliptArray.length === 3) {
                const parentId = `${sliptArray[1]}.${sliptArray[2]}`;
                r[parentId] = r[parentId] || [];
                r[parentId].push(a);
            } else if (sliptArray.length === 2) {
                const parnetCode = a.parentId;
                r[parnetCode] = r[parnetCode] || [];
                r[parnetCode].push(a);
            } else if (sliptArray.length === 1) {
                r[catItem] = r[catItem] || [];
                r[catItem].push(a);
            }
            return r;
        }, Object.create(null));
    }

    private checkOnIntermediate(list: any, displayFor: any, itemUpdated: any) {
        const classification = this.classificationDisplayList.classification;
        const subject = this.classificationDisplayList.subject;
        // const framework = this.classificationDisplayList.framework;
        if (displayFor === classification.modelKey) {
            // if (this.classification.length) {
            const doNothing = 'nothing';
            // }

        } else if (displayFor === subject.modelKey) {
            const itemParentId = itemUpdated.id.split('.');
            const itemIndex = this.classification.findIndex((item: any) => item.code === `${itemParentId[0]}`);
            const itemIndexClass = this.classificationDisplayList.classification.itemList.
                findIndex((item: any) => item.code === `${itemParentId[0]}`);
            if (itemIndex !== -1 && itemIndexClass !== -1) {
                const catItem = this.classificationDisplayList.classification.itemList[itemIndexClass];
                const catWiseSubjectList = this.classificationDisplayList.subject.parentWise[itemParentId[0]] || [];
                if (catWiseSubjectList.length > 0 && catWiseSubjectList.length ===
                    this.classification[itemIndex].subjects.length) {
                    this.$set(catItem, 'indeterminate', false);
                    this.$set(catItem, 'checked', true);

                } else if (catWiseSubjectList.length === 0) {
                    this.$set(catItem, 'checked', false);
                    this.$set(catItem, 'indeterminate', false);
                } else if (catWiseSubjectList.length > 0 && catWiseSubjectList.length !==
                    this.classification[itemIndex].subjects.length) {
                    this.$set(catItem, 'checked', true);
                    this.$set(catItem, 'indeterminate', true);
                }
                this.selectORRemove(this.classificationDisplayList.classification.itemList[itemIndexClass],
                    classification.modelKey);
                this.$set(this.classificationDisplayList.classification.itemList, itemIndexClass, catItem);
            }
            // } else if (displayFor === framework.modelKey) {
            //     const doNothing = 'nothing';
        }
    }

    private findAddRemove(obj: any, list: any, isAdd: boolean, displayFor: any) {
        const itemIndex = list.selectedItem.findIndex((item: any) => item.id === obj.id);
        if (isAdd) {
            if (itemIndex === -1) {
                list.selectedItem.push(obj);
            }
        } else if (!isAdd) {
            if (itemIndex !== -1) {
                list.selectedItem.splice(itemIndex, 1);
            }
        }
    }

    private checkParentWise() {
        if (this.isExecutedParentWise) {
            return;
        }
        this.isExecutedParentWise = true;
        for (const key in this.classificationDisplayList) {
            if (Object.prototype.hasOwnProperty.call(this.classificationDisplayList, key)) {
                const element = this.classificationDisplayList[key];
                this.parentIdWise(element, element.modelKey);
                setTimeout(() => {
                    this.isExecutedParentWise = false;
                    this.displaySelectedFooterList(element.modelKey);
                }, 500);
            }
        }
    }

    private displaySelectedFooterList(displayFor: any) {
        const classification = this.classificationDisplayList.classification;
        const subject = this.classificationDisplayList.subject;
        // const fw = this.classificationDisplayList.framework;
        if (displayFor === classification.modelKey) {
            const selectedRecenlty = classification.recentlySelected;
            this.selectedItemDisplayList[displayFor] = classification.parentWise[classification.modelKey] || [];
            this.selectedItemDisplayList[subject.modelKey] =
                subject.parentWise[classification.recentlySelected.id] || [];
            // this.selectedItemDisplayList[fw.modelKey] = fw.parentWise[subject.recentlySelected.id] || [];
        } else if (displayFor === subject.modelKey) {
            const selectedRecenlty = subject.recentlySelected;
            this.selectedItemDisplayList[subject.modelKey] =
                subject.parentWise[classification.recentlySelected.id] || [];
            // this.selectedItemDisplayList[fw.modelKey] = fw.parentWise[subject.recentlySelected.id] || [];
            // } else if (displayFor === fw.modelKey) {
            //     const selectedRecenlty = fw.recentlySelected;
            //     this.selectedItemDisplayList[fw.modelKey] = fw.parentWise[subject.recentlySelected.id] || [];
        }

    }

    private checkForHeaderCheck(displayFor: any) {
        // if (this.selectedItemDisplayList[displayFor].length === 0) {
        //     this.classificationDisplayList[displayFor].indeterminate = false;
        //     this.classificationDisplayList[displayFor].checked = false;
        // }
        // else if ( this.classificationDisplayList[displayFor].itemList.length>0 &&
        // this.selectedItemDisplayList[displayFor].length ===
        // this.classificationDisplayList[displayFor].itemList.length) {
        //     this.classificationDisplayList[displayFor].indeterminate = false;
        //     this.classificationDisplayList[displayFor].checked = true;
        // }
        // else if (this.classificationDisplayList[displayFor].itemList.length>0 &&
        // this.selectedItemDisplayList[displayFor].length !==
        // this.classificationDisplayList[displayFor].itemList.length){
        //     this.classificationDisplayList[displayFor].indeterminate = true;
        //     this.classificationDisplayList[displayFor].checked = false;
        // }
    }

    private indeterminateCheck(selecteditem: any, displayFor: any, itemIndex?: any, updatedItem?: any) {
        const itemSelectedIndex = this.classificationDisplayList[displayFor].selectedItem.
            findIndex((item: any) => item.id === selecteditem.id);
        if (itemSelectedIndex === -1 && selecteditem.indeterminate) {
            // this.classificationDisplayList[displayFor].selectedItem =
            // [...[selecteditem, ...this.classificationDisplayList[displayFor].selectedItem]];
            this.classificationDisplayList[displayFor].selectedItem.push(selecteditem);
        }
    }

    private onParent(item: any) {
        const splitObj = item.id.split('.');
        const itemIndexClass = this.classificationDisplayList.classification.itemList.
            findIndex((itemClass: any) => itemClass.code === `${splitObj[0]}`);
        if (itemIndexClass !== -1) {
            this.classificationDisplayList.classification.itemList[itemIndexClass].indeterminate = true;
        }
        this.indeterminateCheck(this.classificationDisplayList.classification.itemList[itemIndexClass],
            'classification');
    }

    private resetIndeterminate() {
        if (this.classificationDisplayList.classification.itemList.length > 0) {
            for (const iterator of this.classification) {
                iterator.indeterminate = false;
            }
            this.classificationDisplayList.classification.itemList = [];
            setTimeout(() => {
                this.classificationDisplayList.classification.itemList = this.classification;
            });
        }
    }

    private goNext(key: any) {
        // this.userData.classificationSubFwForm = this.classificationDisplayList.subject.parentWise;
        const catKeys = Object.keys(this.classificationDisplayList.subject.parentWise);
        const seletedCatSub: any = {};
        if (catKeys && catKeys.length > 0) {
            for (const iteratorKey of catKeys) {
                const list = this.classificationDisplayList.subject.parentWise[iteratorKey];
                if (list && list.length > 0) {
                    seletedCatSub[iteratorKey] = [];
                    for (const iteratorList of list) {
                        seletedCatSub[iteratorKey].push(iteratorList.id);
                    }
                }
            }
            this.userData.subject_classifications = seletedCatSub;
            this.$emit('onChangeComponent', key, true);
        }
        // console.log('this.userData.classificationSubFwForm', this.userData.classificationSubFwForm);
    }

    private goBack(key: any) {
        this.$emit('onChangeComponent', key);
    }

    private onBackTolist(key: any) {
        this.$emit('onBackParent', key);
    }
}
